import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#152343",
    },
    text: { primary: "#505050", secondary: "#b7b7b7" },
  },
});
